<template>
  <div>
    <div class="table-panel mt-1" v-if="options.panelActions">
      <b-row align-h="start" align-v="center">
        <b-col md="6">
          <b-row align-v="center" v-if="hasActions">
            <b-col sm="2">
              <Label class="labelAction d-none d-sm-block" bold>Ação:</Label>
            </b-col>
            <b-col sm="4">
              <b-dropdown
                id="dropdown-1"
                class="table-actions"
                :disabled="!action.active"
              >
                <template v-slot:button-content>
                  <span class="actionText">
                    {{ action.label }}
                  </span>
                  <chevron-up :size="16" v-if="action.active" class="icon" />
                </template>
                <fragment v-for="(group, index) in groupActions" :key="index">
                  <b-dropdown-item-button
                    v-for="action in group"
                    :key="action.label"
                    :disabled="disableDropdownItem(action)"
                    :class="dropdownItemClass(action)"
                    @click="handleAction(action.action)"
                  >
                    <component
                      :is="action.icon"
                      :data="action.icon"
                      :size="18"
                    />
                    {{ action.label }}
                  </b-dropdown-item-button>

                  <b-dropdown-divider v-if="index + 1 < groupActions.length">
                  </b-dropdown-divider>
                </fragment>
              </b-dropdown>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6" v-if="panelText">
          <b-row align-h="end">
            <Label bold>{{ panelText }}</Label>
          </b-row>
        </b-col>
        <b-col md="6" v-if="searchItems">
          <b-row align-h="end" class="search-action">
            <InputSearch @input="onSearch" v-model="search" />
          </b-row>
        </b-col>
      </b-row>
    </div>

    <transition name="trable-advanced-form">
      <div class="advanced-form-filter" v-if="showAdvancedFormFilter">
        <slot name="form" />
      </div>
    </transition>
    <div class="table-panel table-panel-without-padding">
      <Checkbox
        v-model="selectedAll"
        class="check-all-mobile"
        label="Selecionar todos"
        @input="checkAll"
        border="white"
      />
      <b-table
        show-empty
        small
        stacked="md"
        :items="tableItems"
        :per-page="perPage"
        :page="currentPage"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        class="table"
        :empty-text="emptyText"
        :hover="options.select"
        @row-clicked="handleRowClick"
      >
        <template v-slot:cell(titleMobile)="row">
          <div class="container-title">
            <Checkbox
              v-model="selectedRow[row.item.id]"
              :content="row.item"
              class="check"
              @check="check"
              border="white"
            />
            {{ row.value }}
          </div>
        </template>

        <template v-slot:cell(labelStatus)="row">
          <div
            :id="`cell-status-${row.item.id}`"
            class="cell-status"
            :class="cellStatus(row.value.color)"
          >
            {{ row.value.value }}
          </div>
          <b-tooltip
            placement="bottom"
            :target="`cell-status-${row.item.id}`"
            v-if="tooltipStatusField && row.item[tooltipStatusField]"
          >
            {{ row.item[tooltipStatusField] }}
          </b-tooltip>
        </template>

        <template v-slot:head(select)>
          <div class="container-check">
            <Checkbox
              v-if="hasActions"
              v-model="selectedAll"
              class="check-all"
              @input="checkAll"
            />
          </div>
        </template>

        <template v-slot:cell(select)="row">
          <div class="container-check">
            <Checkbox
              v-if="hasActions"
              v-model="selectedRow[row.item.id]"
              :content="row.item"
              @check="check"
              class="check"
            />
          </div>
        </template>
      </b-table>

      <div class="container-footer" v-if="pagination && totalItems > 0">
        <div class="info-table-row">
          <b-dropdown
            class="mr-2"
            :text="perPageDropdown"
            v-if="showLeftFooterCalcPages"
          >
            <b-dropdown-item-button
              v-for="value in itemsPerPageOptionsFilter"
              :key="value"
              @click="handleItemsPerPage(value)"
            >
              {{ value }}
            </b-dropdown-item-button>
          </b-dropdown>
          <span v-if="showLeftFooterCalcPages">
            <span class="items-per-page">Itens por página | </span>
            {{ startItem }}-{{ endItem }} de {{ totalItems }} itens
          </span>
        </div>
        <div class="info-page">
          <span class="display-page" v-if="showCalcPages"
            >{{ currentPage }} de {{ totalPages }} {{ pageLabel }}</span
          >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalItems"
            :per-page="perPage"
            first-class="hide"
            last-class="hide"
            next-class="navigation"
            prev-class="navigation"
            pills
            class="pagination"
            @change="handlePage"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronUp from 'vue-material-design-icons/ChevronUp';
import SearchIcon from 'vue-material-design-icons/Magnify';
import { Input, Checkbox, Label, InputSearch } from '../Form';
import { Data } from './TableData';

export default {
  name: 'Table',
  props: {
    tooltipStatusField: {
      type: String,
      default: '',
    },
    hasActions: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Data,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    startItem: {
      type: Number,
      default: () => null,
    },
    panelText: {
      type: String,
      default: null,
      required: false,
    },
    showCalcPages: {
      type: Boolean,
      default: true,
    },
    showLeftFooterCalcPages: {
      type: Boolean,
      default: true,
    },
    searchItems: {
      type: Boolean,
      default: true,
    },
    endItem: {
      type: Number,
      default: () => null,
    },
    totalItems: {
      type: Number,
      default: () => null,
    },
    page: {
      type: Number,
    },
    perPage: {
      type: Number,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      loading: () => false,
    },
    itemsPerPageOptions: {
      type: Array,
      default: () => [15, 30, 50, 100],
    },
    emptyText: {
      type: String,
      default: () => 'Nenhum registro foi encontrado.',
    },
    onClickRow: {
      type: Function,
      default: null,
    },
  },
  components: {
    ChevronUp,
    SearchIcon,
    Input,
    Checkbox,
    Label,
    InputSearch,
  },
  data() {
    return {
      currentPage: null,
      tableItems: [],
      selectedAll: false,
      selectedContent: [],
      selectedRow: [],
      search: '',
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      mobileOpen: null,
      advancedFiltersShow: false,
    };
  },
  computed: {
    perPageDropdown() {
      return `${this.perPage}`;
    },
    empty() {
      return !this.loading ? 'Nenhum registro encontrado' : 'Carregando';
    },
    showAdvancedFormFilter() {
      return this.options.advancedFilters && this.advancedFiltersShow;
    },
    action() {
      const items = this.selectedContent.filter((item) => item);
      return {
        active: items.length,
        label: items.length > 0 ? 'Selecione uma ação' : 'Selecione',
      };
    },
    fields() {
      return this.tableData.getFields();
    },
    groupActions() {
      return this.tableData.getActions();
    },
    options() {
      return this.tableData.getOptions();
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.perPage);
    },
    pageLabel() {
      return this.totalPages > 1 ? 'páginas' : 'página';
    },
    itemsPerPageOptionsFilter() {
      return this.itemsPerPageOptions.filter((value) => value !== this.perPage);
    },
  },
  mounted() {
    this.tableItems = this.items;
    this.currentPage = this.page;
  },
  watch: {
    items(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.tableItems = this.items.map((item) => {
          const data = { ...item };
          data._rowVariant = 'mobile-active';
          return data;
        });
      }
    },
    page(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = this.page;
      }
    },
  },
  methods: {
    disableDropdownItem(action) {
      return !!(
        ['cancel', 'consult', 'getXml', 'getDanfse'].includes(action.name) &&
        this.selectedContent.length > 1
      );
    },
    dropdownItemClass(action) {
      return {
        disabled: this.disableDropdownItem(action),
        'button-action': true,
      };
    },
    onSearch() {
      return this.tableData.onSearch(this.search);
    },
    cellStatus(color) {
      return `cell-status-${color}`;
    },
    checkAll(check) {
      if (!check) {
        this.selectedRow = [];
        this.selectedContent = [];
        return;
      }

      this.items.forEach((e) => {
        if (this.selectedContent.includes(e)) return;
        this.selectedRow[e.id] = true;
        this.selectedContent.push(e);
      });
    },
    check({ selected, content }) {
      if (selected) {
        this.selectedContent.push(content);
      } else {
        this.selectedContent = this.selectedContent.filter(
          (value) => value.id !== content.id,
        );
      }
      this.selectedAll = this.selectedContent.length === this.items.length;
    },
    handleAction(action) {
      action(this.selectedContent);
    },
    handleRowClick(item) {
      if (this.onClickRow) {
        this.onClickRow(item);
      }
    },
    handleOpenMobile(index) {
      this.mobileOpen = this.mobileOpen === index ? null : index;
    },
    handleItemsPerPage(value) {
      this.$emit('changeItemsPerPage', value);
    },
    handlePage(value) {
      this.$emit('changePage', value);
    },
    toggleAdvancedFilters() {
      this.advancedFiltersShow = !this.advancedFiltersShow;
    },
  },
};
</script>
